import { pdfjs } from 'react-pdf';

// De worker wordt door Vite gebundeld uit hetzelfde pdfjs-dist package dat
// react-pdf gebruikt. Dat is bewust, om twee redenen:
//
//  1. Versie-drift is onmogelijk. Een handmatig gekopieerde worker in public/
//     liep eerder achter op de engine, wat leidde tot:
//     "The API version does not match the Worker version".
//  2. Vite geeft het bestand een content-hash. Bestanden uit public/ worden
//     letterlijk gekopieerd en houden hun naam, terwijl nginx.conf alle .js
//     serveert met `max-age=31536000, immutable`. Een worker op een vaste URL
//     werd daardoor een jaar lang in de browser vastgezet en bleef ook na een
//     deploy de oude versie draaien.
//
// Legacy-build: zie de pdfjs-dist-alias in vite.config.js. Engine en worker
// moeten uit dezelfde build komen.
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

// Log whether we've already initialized to prevent double initialization
let isInitialized = false;

/**
 * Singleton to manage PDF worker initialization
 */
class PDFWorkerManager {
  constructor() {
    if (isInitialized) {
      console.log('PDF Worker already initialized, skipping');
      return;
    }
    
    this.initialize();
    isInitialized = true;
  }
  
  initialize() {
    // Synchroon zetten: react-pdf zet zelf een default ('pdf.worker.mjs') die
    // niet bestaat. Een Document dat mount voordat wij dit hebben gezet, valt
    // stil terug op een fake worker die in de main thread draait en de UI
    // blokkeert bij grote PDF's.
    // De content-hash in de bestandsnaam verandert alleen als de worker zelf
    // verandert. Toen deze URL korte tijd met het verkeerde content-type werd
    // geserveerd (.mjs viel terug op application/octet-stream), legden browsers
    // die kapotte response vast onder `immutable` — een jaar lang, zonder te
    // revalideren. De cachesleutel bevat de query string, dus hiermee stappen
    // die clients over op een verse entry.
    pdfjs.GlobalWorkerOptions.workerSrc = `${pdfWorkerUrl}?pdfjs=${pdfjs.version}`;
    
    // Configure for better performance
    pdfjs.GlobalWorkerOptions.workerPort = null;
  }
  
  // Singleton instance getter
  static getInstance() {
    if (!PDFWorkerManager.instance) {
      PDFWorkerManager.instance = new PDFWorkerManager();
    }
    return PDFWorkerManager.instance;
  }
}

// Initialize the singleton immediately 
const instance = PDFWorkerManager.getInstance();

export default instance;
